import {HttpContextToken} from '@angular/common/http';

/**
 * Use for requests whose duplicate-name response is rendered as an inline
 * validation error by the submitting form.
 */
export const SUPPRESS_DUPLICATE_NAME_NOTIFICATION = new HttpContextToken<boolean>(() => false);

/**
 * Backend error messages (400 `error.error`) that the caller renders inline,
 * so the interceptor must not duplicate them as a notification.
 */
export const SUPPRESSED_ERROR_NOTIFICATIONS = new HttpContextToken<string[]>(() => []);
